module.exports = __webpack_public_path__ + "img/trademark-3.02595df0.png";